import cx from 'classnames'
import Styles from '../LinkManager.module.scss'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import { IconButton } from 'components/IconButton/IconButton'
import { Trash2 } from 'blaze-ui/icons/20'

export const LinkLoadingState = () => (
  <>
    {[...Array(5)].map((_, index) => (
      <div key={index} className={Styles.linkOption}>
        <div className={cx(Styles.linkBubble, Styles.loading)}>
          <TextFieldLoadingState lines={1} variant="tertiary" fixedHeight={32} />
        </div>
        <IconButton className={Styles.deleteButton} isDisabled>
          <Trash2 />
        </IconButton>
      </div>
    ))}
  </>
)
